import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../common/Button';
import { Caption, Typography } from '../common/Typography';
import CollapsibleNotificationItem from '../notifications/CollapsibleNotificationItem';

/**
 * GuestEmailAssignmentRequestNotificationItem Component
 * Notification item for email assignment requests with link to guest management
 */
const GuestEmailAssignmentRequestNotificationItem = ({ 
  notification, 
  currentUser,
  onUpdate,
  onClose 
}) => {
  const navigate = useNavigate();
  const notificationData = notification.data || {};
  const clubId = notificationData.club_id;
  const clubName = notificationData.club_name || 'the club';
  const userName = notificationData.user_name || 'A user';
  const userEmail = notificationData.user_email || '';

  const handleGoToPlayerManagement = async () => {
    if (onClose) {
      onClose();
    }

    if (clubId) {
      navigate(`/club/${clubId}/settings`, {
        state: {
          activeTab: 'player-management',
          selectedClub: { id: clubId }
        }
      });
    }

    if (onUpdate) {
      onUpdate();
    }
  };

  const detailsContent = (
    <>
      <div className="text-sm">
        <span className="text-text-muted">User: </span>
        <Typography variant="strong" as="span">{userName}</Typography>
      </div>
      {userEmail && (
        <div className="text-sm">
          <span className="text-text-muted">Email: </span>
          <Typography variant="strong" as="span">{userEmail}</Typography>
        </div>
      )}
    </>
  );

  const metadata = clubName && (
    <Caption>Club: {clubName}</Caption>
  );

  return (
    <CollapsibleNotificationItem
      notification={notification}
      borderColor="blue"
      badgeVariant="info"
      detailsContent={detailsContent}
      metadata={metadata}
    >
      <Button
        variant="primary"
        size="small"
        onClick={handleGoToPlayerManagement}
      >
        Review in Player Management
      </Button>
    </CollapsibleNotificationItem>
  );
};

export default GuestEmailAssignmentRequestNotificationItem;
